export const ProcessStatus = {
    ready: "ready",
    starting: "starting",
    no_process: "no_process",
    waiting_to_restart: "waiting_to_restart",
    waiting_for_permission: "waiting_for_permission",
}
